// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"820":"3add6ebd","3375":"3add6ebd"}[chunkId] + ".chunk.css";
};